import isomorphicFetch from "isomorphic-fetch";
import { APIError } from "lib/errors";
import { getStore } from "store";
import config from "../site-config";

export interface IOptions extends RequestInit {
    brandId?: string;
    noDomain?: boolean;
    useCustomErrorCode?: boolean;
}

export const fetch = function (url, options: IOptions = {}) {
    const { noDomain = false, brandId, ...fetchOptions } = options;
    let headers = fetchOptions.headers || {};
    const { scope } = getStore().getState();
    const activeBrand = scope.brand ? scope.brand._id : brandId;
    headers = {
        "x-requested-with": "XMLHttpRequest",
        "Active-Brand": activeBrand,
        module: "default",
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
    };

    if (!noDomain && !url.includes("https:") && !url.includes("http:")) {
        url = config.api + url;
    }

    return isomorphicFetch(url, { credentials: "include", ...fetchOptions, headers });
};

export const fetchJSON = <T>(url, options?: IOptions) =>
    new Promise<T>((resolve, reject) =>
        fetch(url, { noDomain: true, ...options }).then(
            (response) =>
                response.json().then(
                    (data) => {
                        if (!response.ok) {
                            reject(
                                new APIError(
                                    data?.message ?? data?.error ?? "Unknown error",
                                    options?.useCustomErrorCode ? data.code : response.status,
                                    response.statusText,
                                    data?.code ?? response.status
                                )
                            );
                        }
                        resolve(data);
                    },
                    (err) => {
                        const isSyntaxError = err instanceof SyntaxError;
                        const statusCode = (isSyntaxError && response.status) || 500;
                        const statusText = (isSyntaxError && response.statusText) || "Unknown";

                        reject(new APIError(err.message || "Unknown error", statusCode, statusText));
                    }
                ),
            (err) => {
                reject(err);
            }
        )
    );

export default fetch;
